exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre code{white-space:pre-wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./galaxy/scripts/components/Citations.vue?vue&type=style&index=0&lang=css
// module id = 143
// module chunks = 0 1 2 3